<template>
  <div id="wrapper">
    <nhan-su-side-bar index="1"></nhan-su-side-bar>

    <div id="content-wrapper" class="page">
      <div class="container-fluid">
        <a href="#" @click.prevent="goBack">
          <i class="fas fa-arrow-left"></i> Quay lại
        </a>
        <b-card class="mt-3">
          <form @submit.prevent="updateItem" class="row">
            <div class="col-12 col-lg-8">
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">
                  <b>Email</b>
                  <code>*</code>
                </label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    name="email"
                    v-model="email"
                    autocomplete="off"
                    required
                    readonly
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">
                  <b>Họ và tên</b>
                  <code>*</code>
                </label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    name="hovaten"
                    v-model="hovaten"
                    autocomplete="off"
                    required
                    readonly
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">
                  <b>Mật khẩu</b>
                  <code v-show="item == null">*</code>
                </label>
                <div class="col-sm-10">
                  <input
                    id="password"
                    type="password"
                    class="form-control"
                    name="password"
                    v-model="password"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">
                  <b>Nhóm</b>
                </label>
                <div class="col-sm-10">
                  <div class="categorydiv">
                    <ul class="list-group list-group-flush">
                      <li v-for="role in roles" :key="role.id" class="list-group-item">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :value="role.id"
                            :id="role.id"
                            v-model="selectedRoles"
                          />
                          <label class="form-check-label" :for="role.id">{{role.name}}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <b-button variant="info" @click.prevent="updateItem"><i class="fas fa-save mr-2"></i>Lưu</b-button> 
            </div>
          </form>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NhanSuSideBar from "../components/NhanSu/NhanSuSideBar";
export default {
  name: "User",
  components: {
    NhanSuSideBar,
  },
  data() {
    return {
      item: null,
      email: null,
      hovaten: null,
      password: null,
      selectedRoles: [],
      roles: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/role"),
        axios.get(`/api/employeesystem/${to.params.slug}`),
      ])
      .then(
        axios.spread((role, user) => {
          next((vm) => vm.initData(user.data, role.data.items));
        })
      );
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    initData(item, roles) {
      if (item) {
        this.item = item;
        this.email = this.item.email;
        this.hovaten = this.item.hovaten;
        const digits = this.item.role_id.split(",");
        if (!(digits[0] == "" && digits.length == 1))
          this.selectedRoles = digits.map(Number);
      }
      if (roles) {
        // eslint-disable-next-line no-console
        console.log(roles);
        this.roles = roles;
      }
    },
    updateItem() {      
      axios
        .put("/api/employeesystem", {
          id: this.item.id,
          password: this.password,
          selectedRoles: this.selectedRoles,
        })
        .then((res) => {
          this.goBack();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });      
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
